import {Component, Inject, OnInit} from '@angular/core';
import {AppService} from "@irb/app.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {SecurityMasterService} from "@irb/irb-models/security-master/security-master.service";
import {IRebalResponseObject} from "@irb/irb-rebalance/results/results.model";
import {MoveSecuritiesUsageReviewDialogGridLayoutService} from "@irb/irb-editors/editor-security/move-securities-usage-review-dialog/move-securities-usage-review-dialog.grid-layout.service";
import {IrbAgGridExportService} from "@irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-grid-export/irb-ag-grid-export.service";
import {WINDOW} from "@irb/app.tokens";
import {IrbEditorsEvents} from "@irb/irb-editors/irb-editors.events";
import {IrbAppEvents} from "@irb/app.events";
import {IAlertDialogData} from "@irb/app.model";

@Component({ standalone: false,
    selector: 'irb-move-securities-usage-review-dialog',
    templateUrl: './move-securities-usage-review-dialog.component.html',
    styleUrls: ['./move-securities-usage-review-dialog.component.scss']
})
export class MoveSecuritiesUsageReviewDialogComponent implements OnInit {
    loadingSpinner = true;
    warningsArray: any[] = [];
    warningsData: {
        currentGroupSecurity: any,
        responseData: any[],
        hasCashSecurity: boolean,
        groupSecurities: any[],
        smaSecurities: any[],
        externalSecurities: any[],
        processArray: any[]
    };
    continueFunction: (warningsData: any) => {};
    responseObject: IRebalResponseObject;
    disbleContinue = true;
    grid: any;
    gridOptions: any;
    isUiTest = false;
    updateStatusCount = 0;
    progressTimer: any = null;
    frameworkComponents: any;

    constructor(private as: AppService,
                public dialogRef: MatDialogRef<MoveSecuritiesUsageReviewDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public mdd: any,
                private securityMasterService: SecurityMasterService,
                public ges: IrbAgGridExportService,
                private gls: MoveSecuritiesUsageReviewDialogGridLayoutService) {
    }

    ngOnInit(): void {
        this.gridOptions = {
            columnDefs: this.gls.getColumnDefs(),            
            floatingFilter: false,
            overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No securities.</span>",
            context: {componentParent: this}
        };
        this.warningsData = this.mdd.securitiesWarningsData;
        this.continueFunction = this.mdd.continueFunction;
        this.checkSecurityUsage();
        this.frameworkComponents = this.gls.getFrameworkComponents();
    }

    close() {
        this.dialogRef.close();
    }

    onContinue() {
        this.continueFunction(this.warningsData);
        this.dialogRef.close();
    }

    onGridReady(params: any) {
        this.grid = params;
    }

    checkSecurityUsage() {
        const securityIds: number[] = [];
        this.warningsData.processArray?.forEach((security: any) => {
            if (security.securityId) {
                securityIds.push(security.securityId);
            }
        });
        this.securityMasterService.getDetailsBeforeMoveOrDeleteAsync(securityIds)
            .subscribe((response: IRebalResponseObject) => {
                if (response.responseUtilityMap)
                    this.getDetailsBeforeMoveOrDeleteCheckIntervalStart(response.responseUtilityMap.statusId);
            }, () => {
                this.loadingSpinner = false;
            });
    }
    updateProgressBarStatus(response: any) {
        let timeout = (this.updateStatusCount > 10) ? 8000 : (this.updateStatusCount > 2) ? 3000 : 1500;
        if (this.isUiTest)
            timeout = 0;
        this.updateStatusCount++;
        this.progressTimer = setTimeout(() => {
            this.getDetailsBeforeMoveOrDeleteCheckIntervalStart(response.statusId);
        }, timeout);
    }
    getDetailsBeforeMoveOrDeleteCheckIntervalStart(statusId: any) {
        this.securityMasterService.getDetailsBeforeMoveOrDeleteStatusCheck(statusId).subscribe((statusResponse: any) => {
            if (statusResponse.responseStatus === "SUCCESS") {
                const response = statusResponse?.responseUtilityMap;
                const reqStatus = response?.reqStatus?.trim().toUpperCase();
                if (reqStatus === 'FAILED') {
                    this.actionStatusCheckFailed();
                    this.loadingSpinner = false;
                }

                if (reqStatus === 'STARTED' || reqStatus === 'NEW' || reqStatus === 'IN_PROGRESS') {
                    this.updateProgressBarStatus(response);
                }
                if (reqStatus === 'COMPLETED') {
                    this.loadingSpinner = false;
                    this.processResponse(statusResponse);
                }
            } else {
                this.loadingSpinner = false;
                this.progressTimer && clearTimeout(this.progressTimer);
            }
        }, () => {
            this.loadingSpinner = false;
            this.progressTimer && clearTimeout(this.progressTimer);
        });
    }
    actionStatusCheckFailed() {
        this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
            dType: 'ERROR',
            dTitle: '',
            dProceedBtnLabel: '',
            msg: 'An error occurred processing your request.',
            onProceed: () => {
            }
        } as IAlertDialogData);
    }
    processResponse(response: IRebalResponseObject) {
        const securityIds: number[] = [];
        this.warningsData.processArray?.forEach((security: any) => {
            if (security.securityId) {
                securityIds.push(security.securityId);
            }
        });
        if (response.responseStatus === 'SUCCESS') {
            this.responseObject = response;
            const records = response?.responseUtilityMap?.records;
            if ((records?.affectedSecurities) > 0 ||
                (records?.externalSecurities) > 0) {
                this.disbleContinue = true;
                let modelsArr: any[] = [];
                let accountsArr: any[] = [];
                let rebalancesArr: any[] = [];

                securityIds.forEach((entry: any) => {
                    if (records?.modelDetails && records?.modelDetails[entry] && records?.modelDetails[entry] != undefined) {
                        modelsArr.push(records?.modelDetails[entry]);
                    }
                    if (records?.accountDetails && records?.accountDetails[entry] && records?.accountDetails[entry] != undefined) {
                        accountsArr.push(records?.accountDetails[entry]);
                    }
                    if (records?.rebalanceDetails && records?.rebalanceDetails[entry] && records?.rebalanceDetails[entry] != undefined) {
                        rebalancesArr.push(records?.rebalanceDetails[entry]);
                    }
                });


            } else {
                this.disbleContinue = false;
                this.warningsArray = this.getWarnings();
            }
        }
    }

    hasAffectedOrExternalSecurities() {
        let hasAffected = false;
        if ((this.responseObject?.responseUtilityMap?.records?.affectedSecurities) > 0 ||
            (this.responseObject?.responseUtilityMap?.records?.externalSecurities) > 0) {
            hasAffected = true;
        }
        return hasAffected;
    }

    affectedSecurityCount() {
        const securityIds: number[] = [];
        let response = this.responseObject;
        this.warningsData.processArray?.forEach((security: any) => {
            if (security.securityId) {
                securityIds.push(security.securityId);
            }
        });
        let count = (response?.responseUtilityMap?.records?.affectedSecurities +
            (response?.responseUtilityMap?.records?.externalSecurities == undefined ? 0 : response?.responseUtilityMap?.records?.externalSecurities));
        return count;
    }


    viewDetails() {
        let response: IRebalResponseObject = this.responseObject;
        let actionType: string;
        let idsArr: number[] = [];
        actionType = "move";
        this.warningsData?.processArray?.forEach((security: any) => {
            if (security.securityId) {
                idsArr.push(security.securityId);
            }
        });
        if (response !== undefined && response.responseStatus === "SUCCESS") {
            const modelsArr: any = [], accountsArr: any = [], rebalancesArr: any = [], externalSecArr: any = [];
            const records = response?.responseUtilityMap?.records;
            idsArr.forEach((entry) => {
                if (records?.modelDetails && records?.modelDetails[entry]) {
                    records?.modelDetails[entry].forEach((item: any) => {
                        modelsArr.push(item);
                    });
                }

                if (records?.accountDetails && records?.accountDetails[entry]) {
                    records?.accountDetails[entry].forEach((item: any) => {
                        accountsArr.push(item);
                    });
                }

                if (records?.rebalanceDetails && records?.rebalanceDetails[entry]) {
                    records?.rebalanceDetails[entry].forEach((item: any) => {
                        rebalancesArr.push(item);
                    });
                }
                // need this?
                if (records?.extSecDetails && records?.extSecDetails[entry]) {
                    records?.extSecDetails[entry].forEach((item: any) => {
                        externalSecArr.push(item);
                    });
                }
            });

            // underlay.hide();

            let openWindowContent = '', affectedModel = records?.affectedModel;
            let affectedAccounts = records?.affectedAccounts;
            let affectedRebalances = records?.affectedRebalances;
            let affectedSecurities = records?.affectedSecurities;
            let secWithModels = records?.secWithModels;
            let secWithAccounts = records?.secWithAccounts;
            let secWithRebalances = records?.secWithRebalances;
            let externalSec = records?.externalSecurities;
            openWindowContent += '<link type="text/css" rel="stylesheet" href="/irebal/resources/css/viewDetails.css"/>';
            openWindowContent += '<h1>' + ((actionType === "delete") ? "Deletion" : "Move") + '&nbsp;Refusal Detail</h1>';
            openWindowContent += '<div style="margin-top:10px;">' + ((actionType === "delete") ? "Deletion" : "Movement") + '&nbsp;of&nbsp;' +
                ((affectedSecurities > 1) ? 'securities' : 'security') + '&nbsp;in iRebal cannot be completed due to the following conditions:</div>';
            //msg = openWindowContent;
            //openWindowContent = "";
            if (modelsArr.length > 0) {
                openWindowContent += '<div style="margin-top:30px;"><i><b>' + ((secWithModels > 1) ? 'These selected securities cannot be&nbsp;' : 'This selected security cannot be&nbsp;') +
                    ((actionType == "delete") ? "deleted" : "moved") + '&nbsp;because&nbsp;' + ((secWithModels > 1) ? '&nbsp;they<br/>are' : '&nbsp;it<br/>is') +
                    '&nbsp;targeted in the models as noted:</b></i></div>';
                openWindowContent += '<div style="margin-top:20px;" class="overlayTable">';
                modelsArr.forEach((entry: any) => {
                    openWindowContent += '<div style="width:100%;height:20px;"><span style="width:100px;"><b>' + entry.securitySymb + '</b></span>';
                    openWindowContent += '<span style="width:190px;">has a&nbsp;<i>Target%</i>&nbsp;of&nbsp;' + entry.targetPerc + '% in</span>';
                    openWindowContent += '<span style="width:150px;">' + entry.modelName + '</span>';
                    openWindowContent += '<span style="width:244px;">' + ((entry.modelDesc && entry.modelDesc != null) ? entry.modelDesc : "") + '</span></div>';
                });
                openWindowContent += '</div><div style="margin-top:20px;">To&nbsp;' + ((actionType === "delete") ? "delete" : "move");
                if (secWithModels > 1) {
                    openWindowContent += '&nbsp;any of these securities, you must edit&nbsp;' + ((affectedModel > 1) ? 'any models' : 'model') + '&nbsp;in which they are targeted, and un-target&nbsp;' + ((affectedModel > 1) ? 'them' : 'it') + '.</div>';
                } else {
                    openWindowContent += '&nbsp;this security, you must edit&nbsp;' + ((affectedModel > 1) ? 'any models' : 'model') + '&nbsp;in which it is targeted, and un-target&nbsp;' + ((affectedModel > 1) ? 'them' : 'it') + '.</div>';
                }
            }
            if (accountsArr.length > 0) {
                openWindowContent += '<div style="margin-top:30px;"><i><b>' + ((secWithAccounts > 1) ? 'These selected securities cannot be&nbsp;' : 'This selected security cannot be&nbsp;') +
                    ((actionType === "delete") ? "deleted" : "moved") + '&nbsp;because&nbsp;' + ((secWithAccounts > 1) ? 'they<br/>are' : 'it<br/>is') +
                    '&nbsp;specified as SMA symbols for the accounts as noted:</b></i></div>';
                openWindowContent += '<div style="margin-top:20px;" class="overlayTable">';
                accountsArr.forEach((entry: any) => {
                    openWindowContent += '<div style="width:100%;height:20px;"><span style="width:100px;"><b>' + entry.securitySymb + '</b></span>';
                    openWindowContent += '<span style="width:220px;">is the SMA Security for account:</span>';
                    openWindowContent += '<span style="width:100px;">' + entry.accountNumber + '</span>';
                    openWindowContent += '<span style="width:350px;">' + entry.accountName + '</span></div>';

                });
                openWindowContent += '</div><div style="margin-top:20px;">To&nbsp;' + ((actionType === "delete") ? "delete" : "move");
                if (secWithAccounts > 1) {
                    openWindowContent += '&nbsp;any of these securities, you must edit the SMA&nbsp;' + ((affectedAccounts > 1) ? 'accounts' : 'account') +
                        ', and un-specify&nbsp;' + ((affectedAccounts > 1) ? 'them' : 'it') + 'as the SMA security.</div>';
                } else {
                    openWindowContent += '&nbsp;any of this security, you must edit the SMA&nbsp;' + ((affectedAccounts > 1) ? 'accounts' : 'account') +
                        ', and un-specify&nbsp;' + ((affectedAccounts > 1) ? 'them' : 'it') + '&nbsp;as the SMA security.</div>';
                }
            }
            if (rebalancesArr.length > 0) {
                openWindowContent += '<div style="margin-top:30px;"><i><b>' + ((secWithRebalances > 1) ? 'These selected securities cannot be&nbsp;' : 'This selected security cannot be&nbsp;') +
                    ((actionType === "delete") ? "deleted" : "moved") + '&nbsp;because&nbsp;' + ((secWithRebalances > 1) ? '&nbsp;they<br/>are' : '&nbsp;it<br/>is') +
                    '&nbsp;being used in the scheduled rebalances listed below:</b></i></div>';
                openWindowContent += '<div style="margin-top:20px;" class="overlayTable">';
                rebalancesArr.forEach((entry: any) => {
                    openWindowContent += '<div style="width:100%;height:20px;"><span style="width:100px;"><b>' + entry.securitySymb + '</b></span>';
                    openWindowContent += '<span style="width:250px;">is being used in the scheduled rebalance:</span>';
                    openWindowContent += '<span style="width:250px;">' + entry.rebalanceName + '</span>';
                    openWindowContent += '<span style="width:150px;">' + entry.analysisCreatedBy + '</span></div>';
                });
                openWindowContent += '</div><div style="margin-top:20px;">To&nbsp;' + ((actionType === "delete") ? "delete" : "move");
                if (secWithRebalances > 1) {
                    openWindowContent += '&nbsp;any of these securities, you must remove either delete the scheduled&nbsp;' +
                        ((affectedRebalances > 1) ? 'rebalances' : 'rebalance') + '&nbsp;listed above, or remove these securities from&nbsp;' +
                        ((affectedRebalances > 1) ? 'them.' : 'it.') + '</div>';
                } else {
                    openWindowContent += '&nbsp;this security, you must either delete the scheduled ' +
                        ((affectedRebalances > 1) ? 'rebalances' : 'rebalance') + '&nbsp;listed above, or remove this security from&nbsp;' +
                        ((affectedRebalances > 1) ? 'them.' : 'it.') + '</div>';
                }
            }
            if (externalSecArr.length > 0) {
                openWindowContent += '<div style="margin-top:30px;"><i><b>' + ((externalSec > 1) ? 'These selected securities cannot be&nbsp;' : 'This selected security cannot be&nbsp;') +
                    ((actionType == "delete") ? "deleted" : "moved") + '&nbsp;because&nbsp;' + ((externalSec > 1) ? '&nbsp;they<br/>are' : '&nbsp;it<br/>is') +
                    '&nbsp;an external security:</b></i></div>';
                openWindowContent += '<div style="margin-top:20px;" class="overlayTable">';
                externalSecArr.forEach((entry: any) => {
                    openWindowContent += '<div style="width:100%;height:20px;"><span style="width:100px;"><b>' + entry + '</b></span></div>';
                });
                openWindowContent += '</div><div style="margin-top:20px;">Consider removing the external ' + ((externalSec > 1) ? 'securities' : 'security') + ' from the account and replacing with the group security.</div>';

            }
            const openWindow = window.open("", "_blank");
            if (openWindow && openWindow.document) {
                const doc = openWindow.document;
                const bodyElements = doc.getElementsByTagName('body');
                const bodyElement = bodyElements[0];
                const fragment = doc.createRange().createContextualFragment(openWindowContent);
                bodyElement.appendChild(fragment);
            }
        }
    }


    getContinueButtonText() {
        let btnText = "Continue";
        if (!this.hasAffectedOrExternalSecurities()) {
            if (this.warningsData?.processArray?.length > 0) {
                btnText = "Proceed. Move the selected securities"
            } else {
                btnText = "Proceed. Move the selected security"
            }
        }
        return btnText;
    }

    // hasWarnings() {
    //     let warningsarray = [];
    //     let response = this.responseObject;
    //     if (response && response.responseData) {
    //         this.warningsData?.processArray?.forEach((security: any) => {
    //             let responseDataItem = response.responseData[security.securityId];
    //             if (responseDataItem && responseDataItem.length > 0) {
    //                 responseDataItem.forEach((item: any) => {
    //                     warningsarray.push(item);
    //                 });
    //             }
    //         });
    //     }
    //     return warningsarray?.length > 0;
    // }
    private getWarnings() {
        let warningsarray: any[] = [];
        let response = this.responseObject;
        if (response && response.responseData) {
            this.warningsData.processArray?.forEach((security: any) => {
                let responseDataItem = response.responseData[security.securityId];
                if (responseDataItem && responseDataItem.length > 0) {
                    responseDataItem.forEach((item: any) => {
                        item.relatedToNameAndDescription = item?.relatedToName + " " + item?.relatedToDesc;
                        warningsarray.push(item);
                    });
                }
            });
        }
        return warningsarray;
    }

    hasAffectedSecuritiesAndPortfolios() {
        let response = this.responseObject;
        let hasAffectedPortAndSecurities = false;
        if (response?.responseUtilityMap?.records?.securitiesAffected > 0 && response?.responseUtilityMap?.records?.affectedPortfolios > 0) {
            hasAffectedPortAndSecurities = true;
        }
        return hasAffectedPortAndSecurities;
    }

    exportList() {
        let colDef = this.gls.getColumnDefs();
        //get the data in sorted order
        let exportSortedData: any[] = [];
        this.grid.api.forEachNodeAfterFilterAndSort((node: any) => {
            exportSortedData.push(node.data);
        });
        let result = JSON.parse(JSON.stringify(exportSortedData));
        this.ges.setPrefix("deleteOrMoveSecuritiesExport", "csv");
        this.ges.setExportOptions(result, this.grid.api, this.gridOptions, colDef);
    }
}

